import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {RoutePaths} from '../../config/routeConstants';
import LanguageSwitcher from '../common/LanguageSwitcher';
import {ReactComponent as HelpIcon} from '../../assets/icons/help-circle-gray.svg';
import Manual from "../common/Manual";

const NavBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 36px;
    padding-bottom: 0;
`;

const ActionsContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 16px;
`;

const Line = styled.div`
    background: #f0f0f0;
    height: 1px;
    width: 100%;
`;

const NavBar = () => {
    return (
        <NavBarContainer>
            <ActionsContainer>
                <LanguageSwitcher/>
                <Manual/>
            </ActionsContainer>
            <Line/>
        </NavBarContainer>
    );
};

export default NavBar;
